import { DepartmentTiny, Qualification, SpecialtyShort } from '../settings';

export const RECURRENCE_TYPES = {
  SINGLE: 'single',
  SHIFT_SERIES: 'series',
  SHIFT_ROTATION: 'rotation',
} as const;
export type RecurrenceType = (typeof RECURRENCE_TYPES)[keyof typeof RECURRENCE_TYPES];
export const RECURRENCE_TYPES_LIST = Object.values(RECURRENCE_TYPES);

export type ShiftTemplate = {
  id: string; // 'shifttemplate-00000000000000000000000000';
  name: string;
  shiftTimePresetTemplate: {
    id: string; //'shifttimepresettemplate-00000000000000000000000000';
    name: string;
    startTime: string; //'00:00:00';
    durationInSeconds: number;
  };
  recurrenceType: RecurrenceType;
  startTime: string; // '00:00:00';
  durationInSeconds: number;
  durationInDays: number;
  seriesRecurrence: string;
  rotationRecurrence: string;
  departmentNode: DepartmentTiny;
  subDepartmentNode: DepartmentTiny;
  specialty: SpecialtyShort | null;
  qualifications: Qualification[];
  tags: string[];
};

export type TemplateListItem = ShiftTemplate;
